import React from 'react';
import PropTypes from 'prop-types';

import mergeClassName from 'merge-class-names';

import { createUseStyles } from '../../palette';
import decorate from '../../common/utils/decorate';

const useMainStyles = createUseStyles((theme) => ({
  icon: {
    objectFit: 'contain',
    objectPosition: 'left',

    width: 85,
    height: 22
  }
}));

const useVariantStyles = createUseStyles((theme) => ({
  right: {
    objectPosition: 'right'
  }
}));

const useSizeStyles = createUseStyles((theme) => ({
  sm: {
    width: 35,
    height: 9
  }
}));

export default decorate(
  class extends React.PureComponent {
    static decorateWith = {
      classes: {
        main: useMainStyles,
        variant: useVariantStyles,
        size: useSizeStyles
      }
    };

    static propTypes = {
      variant: PropTypes.string,
      size: PropTypes.string
    };

    static defaultProps = {};

    constructor(props) {
      super(props);
    }

    componentDidMount() {}

    componentWillUnmount() {}

    componentDidUpdate(prevProps, prevState, snapshot) {}

    render() {
      const { classes, children, variant, size, ...props } = this.props;

      const mergedClassName = mergeClassName(
        classes.main.icon,
        variant && classes.variant[variant],
        size && classes.size[size]
      );

      return <img {...props} className={mergedClassName} />;
    }
  }
);
